module.exports = __webpack_public_path__ + "static/desktop/img/travel.3c11f665.jpg";